export default __webpack_public_path__ + "static/media/redo.ed3aa82b.svg";